// Single source of truth for how student names render across the V2
// onboarding flow. We capitalize at the display layer (rather than mutating
// the saved value) so we don't risk normalising names the parent typed in a
// non-Western convention or with intentional casing.
//
// Examples:
//   "tim"        → "Tim"
//   "mary jo"    → "Mary Jo"
//   "anne-marie" → "Anne-Marie"
//   "McDonald"   → "McDonald" (only the first letter of each part is touched)
//
// Whitespace and hyphens are preserved as their own tokens so multi-word and
// hyphenated names get every segment capitalised.
export const titleCaseName = (name: string | null | undefined): string => {
	if (!name) return "";
	return name
		.split(/(\s+|-)/)
		.map(part => {
			if (part.length === 0) return part;
			if (/^\s+$/.test(part) || part === "-") return part;
			return part.charAt(0).toUpperCase() + part.slice(1);
		})
		.join("");
};
